const STORAGE_KEY = 'postLoginRedirect';

const isRestorable = (route: string | null | undefined): route is string =>
  !!route && route !== '/' && !route.startsWith('/login');

const currentRoute = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }
  return window.location.hash.replace(/^#/, '');
};

export const savePostLoginRedirect = (): void => {
  const route = currentRoute();
  if (!isRestorable(route)) {
    return;
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, route);
  } catch (e) {
    console.warn('Failed to save post-login redirect:', e);
  }
};

export const peekPostLoginRedirect = (): string | undefined => {
  try {
    const route = sessionStorage.getItem(STORAGE_KEY);
    return isRestorable(route) ? route : undefined;
  } catch (e) {
    console.warn('Failed to read post-login redirect:', e);
    return undefined;
  }
};

export const clearPostLoginRedirect = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.warn('Failed to clear post-login redirect:', e);
  }
};
